<template>
  <div id="app" :style="style">
    <RouterView />
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { mapState } from "vuex";
import { bind } from "@utils/eventListener";
import { colors } from "@utils/tailwind";
import { checkConsent } from "@utils/cookieConsent";
import { welcome, cookies } from "@c/Block/BlockModal";
import { title } from "@utils/config";

export default {
  name: "App",

  meta: {
    titleTemplate: titleChunk => {
      // If undefined or blank then we don't need the hyphen
      return titleChunk ? `${titleChunk} - ${title}` : title;
    }
  },

  computed: {
    ...mapState({
      bgColor: state => state.ui.bgColor,
      fgColor: state => state.ui.fgColor
    }),
    style() {
      return {
        backgroundColor: colors[this.bgColor],
        color: colors[this.fgColor]
      };
    }
  },

  created() {
    this.$store.dispatch("setResizeHandlers");
    bind(
      window,
      "resize",
      debounce(() => this.$store.dispatch("setResizeHandlers"), 150)
    );
  },

  mounted() {
    this.$store.commit("addModal", welcome);

    if (!checkConsent()) {
      this.$store.commit("addModal", cookies);
    }
  }
};
</script>

<style src="@assets/css/index.css" />
